import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';

const SITE_NAME = 'AFII';
const DEFAULT_TITLE = 'AFII | African Future Intelligence Initiative';
const DEFAULT_DESC = "Free pathways into AI, fintech, economics, futurism, and resource-management intelligence. Built for Africa's next generation of thinkers — open to anyone curious enough to join.";
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_afii-future/artifacts/zz1rxbi3_image.png';
const CANONICAL_BASE = 'https://africanfutureintelligenceinitiative.com';

export function PageSEO({ title, description, path, image, type, jsonLd }) {
  const fullTitle = title ? title + ' | ' + SITE_NAME : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const canonical = CANONICAL_BASE + (path || '');
  const ogImage = image || DEFAULT_IMAGE;
  const ogType = type || 'website';

  // Handle JSON-LD via direct DOM manipulation (Helmet has issues with script children)
  useEffect(() => {
    if (!jsonLd) return;
    const existing = document.getElementById('page-jsonld');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = 'page-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);
    return () => { const el = document.getElementById('page-jsonld'); if (el) el.remove(); };
  }, [jsonLd]);

  return (
    <Helmet
      title={fullTitle}
      meta={[
        { name: 'description', content: desc },
        { property: 'og:title', content: fullTitle },
        { property: 'og:description', content: desc },
        { property: 'og:type', content: ogType },
        { property: 'og:url', content: canonical },
        { property: 'og:image', content: ogImage },
        { property: 'og:site_name', content: 'African Future Intelligence Initiative' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: fullTitle },
        { name: 'twitter:description', content: desc },
        { name: 'twitter:image', content: ogImage },
      ]}
      link={[
        { rel: 'canonical', href: canonical }
      ]}
    />
  );
}
